import {
    GET_SPECIALTY_BY_BOOKING_REPORT_REQUEST,
    GET_SPECIALTY_BY_BOOKING_REPORT_SUCCESS,
    GET_SPECIALTY_BY_BOOKING_REPORT_ERROR
} from "../actions/types";

export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_SPECIALTY_BY_BOOKING_REPORT_REQUEST:
            return {
                loading: true,
            };
        case GET_SPECIALTY_BY_BOOKING_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                payload
            };
        case GET_SPECIALTY_BY_BOOKING_REPORT_ERROR:
            return {
                ...state,
                loading: false,
                payload,
            };

        default:
            return state;
    }
}